import { render, staticRenderFns } from "./promotion-review.vue?vue&type=template&id=57847d8e&"
import script from "./promotion-review.vue?vue&type=script&lang=js&"
export * from "./promotion-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports